import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { testimonials } from '../data/content';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-mist" data-id="element-143" data-mp="3ayi09lag3jqs">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-144" data-mp="3700p8qnwlp43">
        <SectionHeader id="testimonios" title="Lo que dicen quienes ya empezaron" description="De preparar cada tema desde cero a tener una estructura más clara para organizar las clases de electrónica." data-id="element-145" data-mp="31zwc9am7fcim" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-146" data-mp="2s3097kf2rilg">
          {testimonials.map((t, i) => <li key={t.author} className={`flex flex-col rounded-lg border border-navy/10 bg-white p-2.5 shadow-sm sm:p-3 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-147" data-mp="v859fwccnb29" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-148" data-mp="m51a7p5h516u">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={14} aria-hidden="true" className="fill-energy text-energy" data-id="element-149" data-mp="78tub113mlxd" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-[0.8rem] leading-snug text-navy sm:text-sm" data-id="element-150" data-mp="c8y3s73lage3">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-2" data-id="element-151" data-mp="14vj25rihfsr5">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-brand font-condensed text-xs font-bold text-white" data-id="element-152" data-mp="14ur50c98lmyr">
                  {initials(t.author)}
                </span>
                <div className="min-w-0" data-id="element-153" data-mp="v3d1lte6030c">
                  <p className="font-condensed text-sm font-bold text-navy" data-id="element-154" data-mp="1iu90tbkya0hm">{t.author}</p>
                  <p className="text-xs leading-tight text-navy/65" data-id="element-155" data-mp="1nma96mezz72d">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <CtaBlock data-id="element-156" data-mp="1xfmvrbdxn1vu" />
      </div>
    </section>;
}